import { useEffect } from "react";

const SHIPPING_ADDRESS_FORM_SELECTOR = '[data-component-name="ShippingAddressForm"]';

function getErrorsToScrollTo() {
  const shippingAddressForm = document.querySelector(SHIPPING_ADDRESS_FORM_SELECTOR);
  const shippingAddressErrors = shippingAddressForm?.querySelectorAll(".error");

  if (shippingAddressErrors?.length) {
    return shippingAddressErrors;
  }

  return document.querySelectorAll(".error");
}

export default function useScrollToError(formApi) {
  useEffect(() => {
    if (formApi.scrollToError) {
      const errors = getErrorsToScrollTo();
      if (errors.length) {
        const error = errors[0];
        error.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  }, [formApi.scrollToError]);
}
